module.exports = __webpack_public_path__ + "c0d1d82e9cd1fdfa2271bfbd02420972.png";